const base = "/examples/ai";

export const aiVideoExamples = [
  {
    id: "product-content",
    title: "Video Konten Produk",
    description: "Contoh video dengan model, demonstrasi produk, dan narasi untuk konten media sosial.",
    src: `${base}/product-content.mp4`,
    poster: `${base}/content-poster.webp`,
  },
  {
    id: "cinematic",
    title: "Iklan Sinematik",
    description: "Contoh video yang menyorot bahan, bentuk, dan detail produk lewat visual sinematik.",
    src: `${base}/cinematic.mp4`,
    poster: `${base}/cinematic-poster.webp`,
  },
];

export const aiPhotoExamples = [
  "Tumbler panda dengan latar hutan bambu",
  "Tumbler panda di meja dengan cahaya matahari",
  "Tumbler panda di atas batu dengan latar air",
  "Tumbler panda dengan latar studio pastel",
].map((alt, index) => ({ src: `${base}/photo-${index + 1}.webp`, alt }));
